export default __webpack_public_path__ + "static/media/undraw_Profile_re_4a55.d8ffe51a.png";